module.exports = __webpack_public_path__ + "static/media/HomeStoryImage4.c8a0151d.jpg";